import React from "react";
import Hint from "./Hint";

/**
 * MyDayHeader — "Sunday · April 19" + "Good morning, Dhruv" + 3-priority progress pill.
 * Apple-minimal typographic header. Replaces the existing "MY DAY · DATE" header.
 */
export default function MyDayHeader({ userName, priorities = [] }) {
  const now = new Date();
  const dateStr = now.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });

  const hour = now.getHours();
  const greeting = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";
  const firstName = (userName || "").split(" ")[0] || "there";

  const doneCount = priorities.filter((p) => p && p.completed).length;
  const totalCount = 3;

  return (
    <div className="dm-header-row" style={{
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "space-between",
      marginBottom: 32,
      gap: 16,
      flexWrap: "wrap",
    }}>
      <div>
        <div style={{
          fontSize: 13,
          color: "var(--t3)",
          marginBottom: 6,
          letterSpacing: "-0.005em",
          fontWeight: 500,
        }}>
          {dateStr}
        </div>
        <div style={{
          fontFamily: "var(--font-sans)",
          fontSize: 28,
          fontWeight: 600,
          color: "var(--t1)",
          letterSpacing: "-0.02em",
          lineHeight: 1.15,
        }}>
          {greeting}, {firstName}
        </div>
      </div>

      {totalCount > 0 && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            padding: "8px 14px",
            background: "var(--s1)",
            border: "1px solid var(--bdr)",
            borderRadius: 999,
            color: "var(--t2)",
            fontSize: 13,
            fontWeight: 500,
          }}
          title={`${doneCount} of ${totalCount} priorities done today`}
        >
          <Hint id="me.daily_3">
            Your 3 daily commitments. Set them in the morning, mark done as you go, reflect at end-of-day. Forces focus on what actually moves things.
          </Hint>
          <div style={{ display: "flex", gap: 5 }}>
            {Array.from({ length: totalCount }).map((_, i) => (
              <span
                key={i}
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: i < doneCount ? "var(--g)" : "var(--t4, #3e3e3e)",
                  boxShadow: i < doneCount ? "0 0 10px rgba(34,197,94,.4)" : "none",
                  transition: "all .25s",
                }}
              />
            ))}
          </div>
          <span>{doneCount} of {totalCount}</span>
        </div>
      )}
    </div>
  );
}
